import React, { Component } from "react";
import { connect } from "react-redux";
import StatsIcon from "material-ui/svg-icons/action/trending-up";
import VentesIcon from "material-ui/svg-icons/action/shopping-cart";
import CommandesIcon from "material-ui/svg-icons/content/content-paste";
import TransactionsIcon from "material-ui/svg-icons/action/credit-card";
import ClientsIcon from "material-ui/svg-icons/social/person";
import AccountingIcon from "material-ui/svg-icons/editor/format-align-justify";
import AdminIcon from "material-ui/svg-icons/image/edit";
import MerchantIcon from "material-ui/svg-icons/action/store";
import UserIcon from "material-ui/svg-icons/action/supervisor-account";
import ShareIcon from "material-ui/svg-icons/social/share";

import NavItem from "./NavItem";
import Selectfield from "./SelectField";

import Token from "../services/token";

import {
  navigationOpenItem,
  navigationCloseItem,
  menuClose,
  changeUserMerchant,
  getUserMerchants
} from "./actions";

const ICONS = {
  StatsIcon: StatsIcon,
  VentesIcon: VentesIcon,
  CommandesIcon: CommandesIcon,
  TransactionsIcon: TransactionsIcon,
  ClientsIcon: ClientsIcon,
  AccountingIcon: AccountingIcon,
  AdminIcon: AdminIcon,
  MerchantIcon: MerchantIcon,
  UserIcon: UserIcon,
  ShareIcon: ShareIcon
};

const icon = name => {
  const Icon = ICONS[name];
  return <Icon />;
};

const navItems = (to, items, closeDrawer, openItem, closeItem, level = 0) => {
  if (items) {
    return items.map((item, index) =>
      item.divider ? (
        <hr key={index} />
      ) : (
        <NavItem
          key={index}
          selected={to}
          to={item.to}
          level={level}
          title={item.label}
          opened={item.opened}
          icon={icon(item.icon)}
          openItem={openItem}
          closeItem={closeItem}
          closeDrawer={closeDrawer}
        >
          {navItems(
            to,
            item.children,
            closeDrawer,
            openItem,
            closeItem,
            level + 1
          )}
        </NavItem>
      )
    );
  }
};

const renderMerchantSelect = (user, changeUserMerchant) => {
  return user.merchants !== undefined && user.merchants.length > 1 ? (
    <Selectfield
      label={"Marchand"}
      onChange={changeUserMerchant}
      value={user.merchant}
    >
      {user.merchants.map(merchant => (
        <option key={merchant.merchant} value={merchant.merchant}>
          {merchant.libelle}
        </option>
      ))}
    </Selectfield>
  ) : null;
};

class Nav extends Component {
  componentDidMount() {
    this.props.getUserMerchants(this.props.user.login);
  }

  closeDrawer = () => {
    this.props.closeMenu();
  };

  openItem = to => {
    this.props.openItem(to);
  };

  closeItem = to => {
    this.props.closeItem(to);
  };

  changeUserMerchant = value => {
    this.props.changeUserMerchant(value, this.props.user);
  };

  renderSmoneyLink() {
    const { user } = this.props;
    if (user.merchant) {
      const url = `/api/smoney?__authorization=${Token.read()}`;
      return (
        <div className="nav-item closed">
          <div className="nav-item--entry">
            <div>
              <a href={url} target="_blank" rel="noopener noreferrer">
                <TransactionsIcon />
                <span>Espace Smoney</span>
              </a>
            </div>
          </div>
        </div>
      );
    }
  }

  render() {
    const { to, items, user } = this.props;
    return (
      <div>
        {renderMerchantSelect(user, this.changeUserMerchant)}
        {navItems(to, items, this.closeDrawer, this.openItem, this.closeItem)}
        {this.renderSmoneyLink(user)}
      </div>
    );
  }
}

/******* Container part **********/

const mapStateToProps = state => ({
  items: state.app.navigation,
  user: state.app.auth.user
});

const mapDispatchToProps = dispatch => ({
  getUserMerchants: login => {
    dispatch(getUserMerchants(login));
  },

  openItem: to => {
    dispatch(navigationOpenItem(to));
  },

  closeItem: to => {
    dispatch(navigationCloseItem(to));
  },

  closeMenu: () => {
    dispatch(menuClose());
  },

  changeUserMerchant: (merchant, user) => {
    dispatch(changeUserMerchant(merchant, user));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Nav);



// WEBPACK FOOTER //
// ./src/app/Nav.js